import { SectionSpecifier } from './use-sectioned-input'

const alphanumeric = /[^A-Za-z0-9]+/g

export function numericSection({
  min,
  max,
  placeholder,
  suffix,
  prefix,
  pad,
  tick
}: {
  min: number
  max: number
  placeholder: string
  suffix?: string
  prefix?: string
  pad?: boolean
  tick?: SectionSpecifier['tick']
}): SectionSpecifier {
  const length = `${max}`.length
  if (suffix?.replace(alphanumeric, '')) {
    throw new Error(`Suffix must be non-alphanumeric: ${suffix}`)
  }
  if (prefix?.replace(alphanumeric, '')) {
    throw new Error(`Suffix must be non-alphanumeric: ${prefix}`)
  }
  function format(number: number) {
    return pad ? `${number}`.padStart(length, '0') : `${number}`
  }

  return {
    type: 'numeric',
    prefix,
    suffix,
    placeholder,
    tick: tick || ((s) => s.value),
    update(state, action) {
      if (!action.value) {
        return {
          value: placeholder,
          referenceValue: ''
        }
      } else {
        const valNumber = Number.parseInt(`${action.value}`)
        if (Number.isNaN(valNumber)) {
          return {
            value: placeholder,
            referenceValue: ''
          }
        } else {
          const number = Number.parseInt(`${state.referenceValue}${action.value}`)
          const exclusiveMatch =
            Number.parseInt(`${number}0`) > max || `${state.referenceValue}${action.value}`.length === length
          if (number >= min && number <= max) {
            return {
              value: format(number),
              referenceValue: exclusiveMatch ? '' : format(number),
              goToNextSection: exclusiveMatch
            }
          } else if (valNumber >= min && valNumber <= max) {
            const exclusiveMatch = Number.parseInt(`${valNumber}0`) > max || `${valNumber}`.length === length
            return {
              value: format(valNumber),
              referenceValue: exclusiveMatch ? '' : format(valNumber),
              goToNextSection: exclusiveMatch
            }
          } else {
            return {
              value: state.value,
              referenceValue: `${state.referenceValue}${action.value}`
            }
          }
        }
      }
    },
    increment(state) {
      const number = Number.parseInt(`${state.value}`)
      if (Number.isNaN(number)) {
        return format(min)
      } else {
        if (number + 1 > max) {
          return pad ? `${min}`.padStart(length, '0') : `${min}`
        } else {
          return pad ? `${number + 1}`.padStart(length, '0') : `${number + 1}`
        }
      }
    },
    decrement(state) {
      const number = Number.parseInt(`${state.value}`)
      if (Number.isNaN(number)) {
        return format(max)
      } else {
        if (number - 1 < min) {
          return pad ? `${max}`.padStart(length, '0') : `${max}`
        } else {
          return pad ? `${number - 1}`.padStart(length, '0') : `${number - 1}`
        }
      }
    }
  }
}
